import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MenuIcon, X } from 'lucide-react';
const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  const handleNavClick = (path: string, hash?: string) => {
    setIsOpen(false);
    if (hash) {
      navigate(path);
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }, 100);
    } else {
      navigate(path);
    }
  };
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'Our Story',
    path: '/our-story',
    hash: '#our-story'
  }, {
    name: 'Events',
    path: '/our-story',
    hash: '#events'
  }, {
    name: 'Wedding Party',
    path: '/our-story',
    hash: '#wedding-party'
  }, {
    name: 'Gallery',
    path: '/our-story',
    hash: '#gallery'
  }, {
    name: 'RSVP',
    path: '/rsvp'
  }, {
    name: 'Gifts',
    path: '/gifts'
  }];
  return <nav className={`fixed w-full z-50 transition-all duration-300 ${scrolled ? 'bg-white bg-opacity-95 shadow-md py-2' : 'bg-transparent py-4'}`} data-id="element-107">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-108">
        <div className="flex justify-between items-center" data-id="element-109">
          <div className="flex items-center cursor-pointer" onClick={() => navigate('/')} data-id="element-110">
            <span className="font-script text-emerald text-2xl" data-id="element-111">
              Abi<span className="text-red-600" data-id="element-112">❤</span>Aye
            </span>
          </div>
          <div className="hidden md:block" data-id="element-113">
            <div className="flex items-center space-x-8" data-id="element-114">
              {navLinks.map(link => <button key={link.name} onClick={() => handleNavClick(link.path, link.hash)} className="font-sans text-sm font-medium text-gray-700 hover:text-emerald transition-colors" data-id="element-115">
                  {link.name}
                </button>)}
            </div>
          </div>
          <div className="md:hidden" data-id="element-116">
            <button onClick={toggleMenu} className="text-gray-700 hover:text-emerald focus:outline-none" data-id="element-117">
              {isOpen ? <X size={24} data-id="element-118" /> : <MenuIcon size={24} data-id="element-119" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile menu */}
      {isOpen && <div className="md:hidden bg-white bg-opacity-95" data-id="element-120">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-121">
            {navLinks.map(link => <button key={link.name} onClick={() => handleNavClick(link.path, link.hash)} className="block w-full text-left py-2 px-4 text-base font-medium text-gray-700 hover:text-emerald" data-id="element-122">
                {link.name}
              </button>)}
          </div>
        </div>}
    </nav>;
};
export default Navbar;